// import React, { useState, useEffect } from 'react';
// import { Plus, Search } from 'lucide-react';
// import IngestionEntityModal from './popups/IngestionEntityModal';
// import { apiService } from '../../../../components/api/apiService';

// const DataIngestion: React.FC = () => {
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [entities, setEntities] = useState<any[]>([]);
//     const [loading, setLoading] = useState(true);
//     const [searchQuery, setSearchQuery] = useState('');



//     const fetchEntities = async () => {
//         setLoading(true);
//         try {
//             const data = await apiService.get('/Entities', {}, 'backend');
//             setEntities(data.entities || []);
//         } catch (err) {
//             console.error('Error fetching entities:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchEntities();
//     }, []);

//     const handleCreateEntity = async (data: any) => {
//         try {
//             const body = {
//                 sourceName: data.sourceName,
//                 description: data.description,
//                 sourceType: data.sourceType || 'api_rest',
//                 connectionDetails: data.connectionDetails,
//                 tags: data.tags || []
//             };


//             await apiService.post('/Entities', body, 'backend');
//             fetchEntities();
//             setShowAddModal(false);
//         } catch (err) {
//             console.error('Error creating entity:', err);
//         }
//     };

// return (
//         <div className="min-h-screen bg-black text-white p-8">
//             {/* Header section matching SS1 */}
//             <div className="flex justify-between items-start mb-6">
//                 <div>
//                     <h1 className="text-2xl font-bold text-white">Entities</h1>
//                     <p className="text-gray-400 text-sm mt-1">
//                         Manage and monitor data sources connected to SelficAI.
//                     </p>
//                 </div>
//                 <button
//                     onClick={() => setShowAddModal(true)}
//                     className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors"
//                 >
//                     <Plus className="w-4 h-4" />
//                     Add Source
//                 </button>
//             </div>

//             {/* Search Bar matching SS1 */}
//             <div className="relative mb-12">
//                 <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
//                 <input
//                     type="text"
//                     placeholder="Search sources..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                     className="w-full bg-neutral-900 border-none rounded-lg pl-12 pr-4 py-3 text-sm focus:ring-1 focus:ring-indigo-500 outline-none transition-all placeholder:text-gray-600"
//                 />
//             </div>

//             {/* Content Area matching SS1 */}
//             <div className="w-full">
//                 {loading ? (
//                     <div className="flex flex-col items-center justify-center py-32 gap-4">
//                         <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
//                         <p className="text-gray-500 text-sm">Loading entities...</p>
//                     </div>
//                 ) : entities.length === 0 ? (
//                     <div className="flex flex-col items-center justify-center py-32 text-center">
//                         <p className="text-gray-500 text-sm font-medium">No data sources found.</p>
//                     </div>
//                 ) : (
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pb-20">
//                         {entities
//                             .filter(e => (e.sourceName || '').toLowerCase().includes(searchQuery.toLowerCase()))
//                             .map(entity => (
//                                 <div key={entity.id} className="bg-neutral-900 p-5 rounded-2xl border border-neutral-800 flex flex-col gap-4 group hover:border-indigo-500/50 transition-all shadow-sm">
//                                     <div className="flex justify-between items-start">
//                                         <div className="p-2 bg-indigo-500/10 rounded-lg text-indigo-400">
//                                             <Plus className="w-5 h-5 rotate-45" /> {/* Placeholder icon */}
//                                         </div>
//                                         <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${entity.status === 'Active' ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-500'}`}>
//                                             {entity.status}
//                                         </span>
//                                     </div>
//                                     <div>
//                                         <h3 className="font-bold text-white text-lg">{entity.sourceName}</h3>
//                                         <p className="text-xs text-gray-500 mt-1 line-clamp-2">{entity.description || 'No description provided.'}</p>
//                                     </div>
//                                     <div className="pt-4 border-t border-neutral-800 flex justify-between items-center text-[10px] text-gray-500 uppercase tracking-wider font-bold">
//                                         <span>{entity.sourceType}</span>
//                                         <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                                             <button className="text-indigo-400 hover:text-indigo-300">Edit</button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                     </div>
//                 )}
//             </div>

//             {showAddModal && (
//                 <IngestionEntityModal
//                     onClose={() => setShowAddModal(false)}
//                     onSubmit={handleCreateEntity}
//                 />
//             )}
//         </div>
//     );
// };

// export default DataIngestion;



import React, { useEffect, useMemo, useState } from 'react';
import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  BadgeCheck,
  Blocks,
  Box,
  Briefcase,
  Building2,
  CircleHelp,
  Cloud,
  Cpu,
  Database,
  FileText,
  FolderKanban,
  FolderOpen,
  Globe2,
  Layers,
  LayoutGrid,
  Network,
  PlusCircle,
  Pencil,
  Sparkles,
  RefreshCcw,
  Table2,
  TableProperties,
  Globe,
  PlugZap,
  Upload,
  Server,
  Table,
  FileSpreadsheet,
  Tags,
  Trash2,
  UserCog,
  ShieldCheck,
  UserCircle2,
  Workflow,
} from 'lucide-react';
import '../../workflows/Workflows.css';
import AddDataSourceModal from './AddDataSourceModal';
import SmartMetadataModal from './SmartMetadataModal';
import { ingestionService } from '../../../../components/api/ingestionService';
import ConfirmDialog from '../../Dialogs/ConfirmDialog';
import RenameModal from '../../common/RenameModal';
import PermissionsAssignmentModal from '../../common/Permissions/PermissionsAssignmentModal';
import IngestionEntityModal from './popups/IngestionEntityModal';
import type { IngestionEntityPayload, DataModelResponse } from './popups/IngestionEntityModal';
import { apiService } from '../../Connections/connectionsApiService';
import { useToast } from '../../../../components/common/Toast';
import DataModelGroupsModal from './DataModelGroupsModal';


const initialDataSources = []

type DataModelGroupOption = { uuid: string; name: string; icon?: string; status?: string };

const GROUP_SIDEBAR_ICON_BY_KEY: Record<string, LucideIcon> = {
  LayoutGrid,
  Database,
  Layers,
  FolderKanban,
  Blocks,
  Table2,
  Workflow,
  Network,
  Cloud,
  Cpu,
  Globe2,
  Building2,
  Briefcase,
  FileText,
  Box,
  Tags,
  ShieldCheck,
  BadgeCheck,
  Sparkles,
  Activity,
  UserCircle2,
};

function GroupSidebarIcon({ iconRef }: { iconRef: string | undefined }) {
  const name = (iconRef ?? 'LayoutGrid').trim();
  const Icon = GROUP_SIDEBAR_ICON_BY_KEY[name] ?? CircleHelp;
  return <Icon className="wf-project-sidebar__ico" strokeWidth={1.75} aria-hidden />;
}

const sourceTypes = [
    { label: 'SqlServer', icon: <Database className="w-4 h-4 mr-2 text-cyan-400" /> },
    { label: 'PostgreSQL', icon: <Database className="w-4 h-4 mr-2 text-cyan-500" /> },
    { label: 'MySQL', icon: <Database className="w-4 h-4 mr-2 text-blue-500" /> },
    { label: 'Oracle', icon: <Database className="w-4 h-4 mr-2 text-red-500" /> },
    { label: 'SQLite', icon: <Database className="w-4 h-4 mr-2 text-gray-400" /> },
    { label: 'NoSQL_MongoDB', icon: <TableProperties className="w-4 h-4 mr-2 text-green-400" /> },
    { label: 'API', icon: <Globe className="w-4 h-4 mr-2 text-yellow-400" /> },
    { label: 'Webhook', icon: <PlugZap className="w-4 h-4 mr-2 text-pink-400" /> },
    { label: 'CSV_Upload', icon: <Upload className="w-4 h-4 mr-2 text-orange-400" /> },
    { label: 'S3_Bucket', icon: <Cloud className="w-4 h-4 mr-2 text-blue-400" /> },
    { label: 'Azure_Blob', icon: <Cloud className="w-4 h-4 mr-2 text-blue-300" /> },
    { label: 'Google_Sheets', icon: <TableProperties className="w-4 h-4 mr-2 text-green-300" /> },
    { label: 'FTP_SFTP', icon: <Server className="w-4 h-4 mr-2 text-purple-400" /> },
    { label: 'Firestore', icon: <TableProperties className="w-4 h-4 mr-2 text-red-400" /> },
    { label: 'Snowflake', icon: <Cloud className="w-4 h-4 mr-2 text-white" /> },
    { label: 'CSV', icon: <Table className="w-4 h-4 mr-2 text-white" /> },
    { label: 'Excel', icon: <FileSpreadsheet className="w-4 h-4 mr-2 text-white" /> }
];

const IngestionList = () => {


    const [activeMetadataSource, setActiveMetadataSource] = useState(null);
    const [search, setSearch] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [editId, setEditId] = useState<string | null>(null);
    const [editInitialData, setEditInitialData] = useState<DataModelResponse | null>(null);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [dsToDelete, setdsToDelete] = useState(false);
    const [selectedDSID, setSelectedDSID] = useState('');
    const [selectedDSName, setSelectedDSName] = useState('');

    // const [dataSources, setDataSources] = useState<any[]>(initialDataSources);
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [renameTarget, setRenameTarget] = useState<{ id: string; name: string } | null>(null);

    const [showAssignmentModal, setAssignmentModal] = useState(false);
    const { showToast } = useToast();
    const [showGroupsModal, setShowGroupsModal] = useState(false);

    const [dataSources, setDataSources] = useState<any[]>(initialDataSources);
    const [loadingDataModels, setLoadingDataModels] = useState(true);
    const [dataModelGroups, setDataModelGroups] = useState<DataModelGroupOption[]>([]);
    const [loadingGroupsSidebar, setLoadingGroupsSidebar] = useState(true);
    /** null = default to first group when any; '__all__' / '__ungrouped__' = explicit. */
    const [selectedGroupKey, setSelectedGroupKey] = useState<string | '__all__' | '__ungrouped__' | null>(null);

    const mapDataModelToCard = (item: {
        id: string;
        modelName: string;
        description?: string;
        type?: string;
        status?: string;
        tags?: string[];
        groupUuid?: string;
        group_uuid?: string;
    }) => ({
        id: item.id,
        name: item.modelName,
        description: item.description || '',
        type: item.type || '—',
        status: item.status || 'Active',
        schedule: 'Manual Trigger',
        tags: Array.isArray(item.tags) ? item.tags : [],
        lastSynced: '—',
        groupUuid: item.groupUuid ?? item.group_uuid ?? '',
    });

    const fetchDataModels = async () => {
        setLoadingDataModels(true);
        try {
            const data = await apiService.get('/DataModels', {}, 'backend');
            const list = data?.dataModels ?? [];
            setDataSources(list.map(mapDataModelToCard));
        } catch (err) {
            console.error('Failed to load data models:', err);
            setDataSources([]);
        } finally {
            setLoadingDataModels(false);
        }
    };

    const loadDataSources = async () => {
        try {
            const tenantId = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
            const apiResults = await ingestionService.loadDataSources(tenantId);
            const mapped = apiResults.map(mapApiToDataSource);
            setDataSources(prev => {
                const combined = [...mapped];
                const unique = Array.from(new Map(combined.map(item => [item.id, item])).values());
                return unique;
            });
        } catch (err) {
            console.error('Failed to load data sources:', err);
        }
    };

    const mapApiToDataSource = (apiItem: any): any => {
        return {
            id: apiItem.id,
            name: apiItem.connectionName,
            type: resolveSourceType(apiItem.sourceType),
            status: apiItem.isActive ? 'Active' : 'Disabled',
            description: apiItem.description || '',
            schedule: 'Manual Trigger',
            tags: apiItem.tags
                ? apiItem.tags
                    .split(',')
                    .map((tag: string) => tag.trim())
                    .filter((tag: string) => Boolean(tag))
                : [],
            lastSynced: apiItem.lastSyncedAt
                ? new Date(apiItem.lastSyncedAt).toLocaleString()
                : 'Never',
        };
    };

    const handleDeleteDataModel = async (id: string): Promise<void> => {
        await apiService.delete(`/DataModels/${id}`, 'backend');
        fetchDataModels();
    };

    const resolveSourceType = (index: number) => {
        const source = sourceTypes[index];
        return source ? source.label : `Type ${index}`;
    };

    const fetchDataModelGroups = async () => {
        setLoadingGroupsSidebar(true);
        try {
            const response = await apiService.get('/datastores/groups', {}, 'backend');
            const raw = Array.isArray(response)
                ? response
                : Array.isArray(response?.groups)
                    ? response.groups
                    : [];
            setDataModelGroups(
                raw.map((g: { uuid: string; name: string; icon?: string; status?: string }) => ({
                    uuid: g.uuid,
                    name: g.name,
                    icon: g.icon,
                    status: g.status,
                })),
            );
        } catch (err) {
            console.error('Failed to load groups for filter:', err);
            setDataModelGroups([]);
        } finally {
            setLoadingGroupsSidebar(false);
        }
    };

    useEffect(() => {
        fetchDataModels();
    }, []);

    useEffect(() => {
        fetchDataModelGroups();
    }, []);

    // Fetch single data model for edit when modal opens with editId
    useEffect(() => {
        if (!showAddModal || !editId) return;
        let cancelled = false;
        setLoadingEdit(true);
        apiService.get(`/DataModels/${editId}`, {}, 'backend')
            .then((raw: DataModelResponse | { dataModel?: DataModelResponse; data?: DataModelResponse }) => {
                if (cancelled) return;
                const data =
                    raw && typeof raw === 'object' && 'dataModel' in raw && raw.dataModel
                        ? raw.dataModel
                        : raw && typeof raw === 'object' && 'data' in raw && raw.data
                            ? raw.data
                            : (raw as DataModelResponse);
                setEditInitialData(data);
            })
            .catch((err) => {
                if (!cancelled) showToast({ type: 'error', message: err.response?.data?.message || err.message || 'Failed to load data model.' });
            })
            .finally(() => {
                if (!cancelled) setLoadingEdit(false);
            });
        return () => { cancelled = true; };
    }, [showAddModal, editId]);

    const effectiveGroupKey = useMemo(() => {
        if (selectedGroupKey === '__all__') return '__all__';
        if (selectedGroupKey === '__ungrouped__') return '__ungrouped__';
        if (selectedGroupKey && dataModelGroups.some((g) => g.uuid === selectedGroupKey)) return selectedGroupKey;
        if (dataModelGroups.length > 0) return dataModelGroups[0].uuid;
        return '__all__';
    }, [selectedGroupKey, dataModelGroups]);

    const rowsForGroup = useMemo(() => {
        if (effectiveGroupKey === '__all__') return dataSources;
        if (effectiveGroupKey === '__ungrouped__') {
            return dataSources.filter((s) => !s.groupUuid);
        }
        return dataSources.filter((s) => s.groupUuid === effectiveGroupKey);
    }, [dataSources, effectiveGroupKey]);

    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        if (!q) return rowsForGroup;
        return rowsForGroup.filter((s) => s.name?.toLowerCase().includes(q));
    }, [rowsForGroup, search]);

    const groupNameForCard = (groupUuid: string) =>
        dataModelGroups.find((g) => g.uuid === groupUuid)?.name ?? '';

    const selectedGroupLabel =
        effectiveGroupKey === '__all__'
            ? 'All groups'
            : effectiveGroupKey === '__ungrouped__'
                ? 'No group'
                : dataModelGroups.find((g) => g.uuid === effectiveGroupKey)?.name ?? 'Group';
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState<string | null>(null);

    const handleSaveEntity = async (data: IngestionEntityPayload) => {
        setSubmitting(true);
        setSubmitError(null);
        try {
            if (editId) {
                await apiService.put(`/DataModels/${editId}`, data, 'backend');
                showToast({ type: 'success', message: 'Data model updated successfully.' });
                setShowAddModal(false);
                setEditId(null);
                setEditInitialData(null);
                fetchDataModels();
            } else {
                const response = await apiService.postWithResponse('/DataModels', data, 'backend');
                if (response.status === 201 || (response.status >= 200 && response.status < 300)) {
                    showToast({ type: 'success', message: 'Data model created successfully.' });
                    setShowAddModal(false);
                    fetchDataModels();
                } else {
                    const msg = response.data?.message || 'Something went wrong.';
                    setSubmitError(msg);
                    showToast({ type: 'error', message: msg });
                }
            }
        } catch (err: any) {
            const message = err.response?.data?.message || err.message || (editId ? 'Failed to update data model.' : 'Failed to create data model.');
            setSubmitError(message);
            showToast({ type: 'error', message });
            console.error('Error saving entity:', err);
        } finally {
            setSubmitting(false);
        }
    };
    return (
        <div className="portal-page flex flex-1 flex-col min-h-0 w-full min-w-0">
            {/* Header */}
            <div className="flex flex-wrap justify-between items-start gap-4 mb-6 shrink-0">
                <div>
                    <h1 className="portal-page-title">Data Models</h1>
                    <p className="portal-page-description">Manage and connect data model entities.</p>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        onClick={() => {
                            setEditId(null);
                            setEditInitialData(null);
                            setLoadingEdit(false);
                            setSubmitError(null);
                            setShowAddModal(true);
                        }}
                        className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2.5 rounded-lg text-sm font-medium shadow-sm hover:shadow transition-all"
                    >
                        <PlusCircle className="w-4 h-4 mr-2" /> Add Source
                    </button>
                    <button
                        type="button"
                        onClick={() => setShowGroupsModal(true)}
                        className="flex items-center bg-neutral-800 hover:bg-neutral-700 text-white px-4 py-2.5 rounded-lg text-sm font-medium border border-neutral-700 transition-colors"
                    >
                        <TableProperties className="w-4 h-4 mr-2" /> Manage Groups
                    </button>
                </div>
            </div>

            <div className="wf-layout-with-sidebar flex-1 min-h-0 min-w-0">
                <aside className="wf-project-sidebar" aria-label="Data model groups">
                    <div className="wf-project-sidebar__head">
                        <span className="wf-project-sidebar__title">Groups</span>
                    </div>
                    <nav className="wf-project-sidebar__nav">
                        {loadingGroupsSidebar ? (
                            <div className="wf-project-sidebar__loading">Loading…</div>
                        ) : (
                            <>
                                {dataModelGroups.map((g) => {
                                    const active = effectiveGroupKey === g.uuid;
                                    return (
                                        <button
                                            key={g.uuid}
                                            type="button"
                                            className={`wf-project-sidebar__item${active ? ' wf-project-sidebar__item--active' : ''}`}
                                            onClick={() => setSelectedGroupKey(g.uuid)}
                                        >
                                            <span className="wf-project-sidebar__item-icon">
                                                <GroupSidebarIcon iconRef={g.icon} />
                                            </span>
                                            <span className="wf-project-sidebar__item-label">{g.name}</span>
                                        </button>
                                    );
                                })}
                                <button
                                    type="button"
                                    className={`wf-project-sidebar__item${effectiveGroupKey === '__ungrouped__' ? ' wf-project-sidebar__item--active' : ''}`}
                                    onClick={() => setSelectedGroupKey('__ungrouped__')}
                                >
                                    <span className="wf-project-sidebar__item-icon">
                                        <FolderOpen className="wf-project-sidebar__ico" strokeWidth={1.75} aria-hidden />
                                    </span>
                                    <span className="wf-project-sidebar__item-label">No group</span>
                                </button>
                                <button
                                    type="button"
                                    className={`wf-project-sidebar__item wf-project-sidebar__item--all${effectiveGroupKey === '__all__' ? ' wf-project-sidebar__item--active' : ''}`}
                                    onClick={() => setSelectedGroupKey('__all__')}
                                >
                                    <span className="wf-project-sidebar__item-icon">
                                        <LayoutGrid className="wf-project-sidebar__ico" strokeWidth={1.75} aria-hidden />
                                    </span>
                                    <span className="wf-project-sidebar__item-label">All</span>
                                </button>
                            </>
                        )}
                    </nav>
                </aside>

                <div className="wf-layout-main flex flex-col min-w-0 min-h-0">
                    <div className="mb-4 shrink-0">
                        <input
                            type="text"
                            placeholder="Search sources..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full min-w-0 px-4 py-2.5 rounded-lg bg-neutral-800 border border-neutral-700 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/50 text-sm transition-colors"
                            aria-label="Search data models"
                        />
                        <p className="mt-2 text-xs text-gray-500">
                            {loadingDataModels
                                ? 'Loading…'
                                : `Showing ${filtered.length} of ${rowsForGroup.length} · ${selectedGroupLabel}`}
                        </p>
                    </div>

                    {/* Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 min-h-0 pb-2">
                {loadingDataModels ? (
                    <div className="col-span-full flex flex-col items-center justify-center py-16 gap-3">
                        <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
                        <p className="text-gray-500 text-sm">Loading data models...</p>
                    </div>
                ) : filtered.map((source) => (
                    <div
                        key={source.id}
                        className="portal-card p-4 hover:border-neutral-700 transition-colors"
                    >
                        <div className="flex items-start justify-between">
                            <div>
                                <h3 className="text-white font-medium text-sm">{source.name}</h3>
                                <p className="text-xs text-gray-400 mt-1">{source.description}</p>
                            </div>
                            <Database className="text-indigo-500 w-4 h-4" />
                        </div>

                        <div className="mt-4 space-y-1 text-xs text-gray-300"> 
                            <div>
                                <span className="text-gray-500">Status:</span>{' '}
                                <span className={source.status === 'Active' ? 'text-green-400' : 'text-red-400'}>
                                    {source.status}
                                </span>
                            </div>
                            {source.groupUuid ? (
                                <div>
                                    <span className="text-gray-500">Group:</span>{' '}
                                    <span className="text-gray-300">{groupNameForCard(source.groupUuid) || source.groupUuid}</span>
                                </div>
                            ) : null}
                            <div>
                                <span className="text-gray-500">Tags:</span>{' '}
                                {(source.tags || []).map((tag: string) => (
                                    <span
                                        key={tag}
                                        className="inline-block bg-neutral-800 text-gray-300 px-2 py-0.5 rounded-full text-[11px] mr-1"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="flex justify-end gap-2 mt-4">
                            <button
                                className="text-indigo-400 hover:text-indigo-300 transition-colors"
                                title="Manage Permissions & Access"
                                onClick={() => setAssignmentModal(true)}
                            >
                                <UserCog className="w-4 h-4" />
                            </button>
                            <button className="text-indigo-400 hover:text-indigo-300" title="Test Sync">
                                <RefreshCcw className="w-4 h-4" />
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    setSubmitError(null);
                                    setEditId(source.id);
                                    setEditInitialData(null);
                                    setLoadingEdit(true);
                                    setShowAddModal(true);
                                }}
                                className="inline-flex items-center gap-1.5 text-yellow-400 hover:text-yellow-300 px-2 py-1 rounded hover:bg-yellow-500/10 transition-colors"
                                title="Edit data model"
                            >
                                <Pencil className="w-4 h-4 shrink-0" />
                                <span className="text-xs font-medium"> </span>
                            </button>
                            <button
                                className="text-red-400 hover:text-red-300"
                                onClick={() => {
                                    setSelectedDSID(source.id);
                                    setSelectedDSName(source.name || '');
                                    setdsToDelete(true);
                                }}
                                title="Delete data model"
                            >
                                <Trash2 className="w-4 h-4" />
                            </button>
                            <button
                                className="text-red-400 hover:text-red-300"
                                title="Trigger Smart Metadata Detection"
                                onClick={() => setActiveMetadataSource(source)}
                            >
                                <Sparkles className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                ))}

                {!loadingDataModels && filtered.length === 0 && (
                    <div className="col-span-full text-center text-gray-500 py-10">No data models found.</div>
                )}
                    </div>
                </div>
            </div>

            {showAddModal && (
                <IngestionEntityModal
                    onClose={() => {
                        setShowAddModal(false);
                        setSubmitError(null);
                        setEditId(null);
                        setEditInitialData(null);
                        setLoadingEdit(false);
                    }}
                    onSubmit={handleSaveEntity}
                    submitting={submitting}
                    submitError={submitError}
                    editId={editId}
                    initialData={editInitialData}
                    loadingEdit={loadingEdit}
                />
            )}
            {dsToDelete && (
                <ConfirmDialog
                    title="Delete data model"
                    message={
                        selectedDSName
                            ? `Are you sure you want to delete "${selectedDSName}"? This action cannot be undone.`
                            : 'Are you sure you want to delete this data model? This action cannot be undone.'
                    }
                    onYes={async () => {
                        try {
                            await handleDeleteDataModel(selectedDSID);
                            setdsToDelete(false);
                            showToast({ type: 'success', message: 'Data model deleted successfully.' });
                        } catch (err: any) {
                            showToast({
                                type: 'error',
                                message: err.response?.data?.message || err.message || 'Failed to delete data model.'
                            });
                        }
                    }}
                    onNo={() => setdsToDelete(false)}
                    onCancel={() => setdsToDelete(false)}
                />
            )}

            {activeMetadataSource && (
                <SmartMetadataModal
                    dataSource={activeMetadataSource}
                    onClose={() => setActiveMetadataSource(null)}
                />
            )}

            {renameTarget && showRenameModal && (
                <RenameModal
                    id={renameTarget.id}
                    currentName={renameTarget.name}
                    module="Ingestion Source"
                    onCancel={() => {
                        setShowRenameModal(false);
                        setRenameTarget(null);
                    }}
                    onSave={({ id, newName }) => {
                        ingestionService.renameIngestion({
                            id,
                            tenantID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                            newTitle: newName,
                        }).then(() => {
                            loadDataSources();
                            setShowRenameModal(false);
                            setRenameTarget(null);
                        });
                    }}
                />
            )}
            {showAssignmentModal && (
                <PermissionsAssignmentModal
                    onClose={() => setAssignmentModal(false)}
                    onSave={() => { }}
                    entityType="entity"
                    entityName="System Entity"
                // Optional: Pass initial permissions
                // initialPermissions={{
                //     departments: [],
                //     users: [],
                //     roles: [],
                //     exclusions: []
                // }}
                />
            )}
            {showGroupsModal && (
                <DataModelGroupsModal
                    onClose={() => {
                        setShowGroupsModal(false);
                        fetchDataModelGroups();
                    }}
                    onSuccess={(message) => showToast({ type: 'success', message })}
                    onError={(message) => showToast({ type: 'error', message })}
                />
            )}
        </div>
    );
};

export default IngestionList;
